import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/dashboard.service';

@Component({
  selector: 'app-trending',
  templateUrl: './trending.component.html',
  styleUrls: ['./trending.component.scss']
})
export class TrendingComponent implements OnInit {
  public trending = []

  constructor(private dashboardService: DashboardService) { }

  ngOnInit() {
    //this.getTrending();
  }

  getTrending() {
    this.dashboardService.getTrending()
      .subscribe(statistic => {
        this.trending = statistic.trending;
      });
  }

}
